import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO } from '../data/siteData';

export default function SEO({
  title,
  description,
  canonical,
  ogImage,
  type = 'website',
  schemaData = null,
}) {
  const fullTitle = title
    ? (title.includes('Hærvejens Træpleje') ? title : `${title} - ${COMPANY_INFO.name}`)
    : `${COMPANY_INFO.name} - Certificerede og uddannede Arborister`;

  const metaDesc =
    description ||
    'Hærvejens Træpleje tilbyder professionel træpleje for private og erhverv. Fra træfældning og topkapning til beskæring og rodfræsning.';

  const image =
    ogImage ||
    'https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traefaeldning.jpg';

  // LocalBusiness structured data
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: COMPANY_INFO.name,
    description: metaDesc,
    telephone: '+4527135787',
    email: COMPANY_INFO.email,
    image: COMPANY_INFO.logoUrl,
    address: {
      '@type': 'PostalAddress',
      streetAddress: COMPANY_INFO.address,
      addressLocality: COMPANY_INFO.city,
      postalCode: COMPANY_INFO.postalCode,
      addressCountry: 'DK',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '55.337316',
      longitude: '9.488559',
    },
    hasMap: COMPANY_INFO.mapsUrl,
    areaServed: [
      'Kolding',
      'Fredericia',
      'Vejle',
      'Horsens',
      'Skanderborg',
      'Aarhus',
      'Trekantområdet',
      'Østjylland',
    ],
    priceRange: '$$',
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={COMPANY_INFO.name} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={image} />

      {/* Structured data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData || localBusinessSchema)}
      </script>
    </Helmet>
  );
}
